import { schema } from 'normalizr';

export const patientFormSchema = new schema.Entity('patientForms');
